import ComptabiliteSimplifieeTab from "@features/comptabilite/components/simplifiee/ComptabiliteSimplifieeTab";
import { createFileRoute } from "@tanstack/react-router";
import { BookOpen } from "lucide-react";

export const Route = createFileRoute("/_app/comptabilite/simplifiee/")({
  staticData: {
    title: "Comptabilité simplifiée",
    icon: BookOpen,
    tab_icon: BookOpen,
    module: "comptabilite",
    order: 70,
    showInTab: true,
    showInNav: true,
    showInBreadcrumb: true,
  },
  component: ComptabiliteSimplifieeTab,
});
